export const docRoute = [
  {
    path: '/doc/private/apply',
    component: () => import('./private/apply')
  },
  {
    path: '/doc/private/info',
    component: () => import('./private/info')
  },
  {
    path: '/doc/video/apply',
    component: () => import('./video/apply')
  }
]



// WEBPACK FOOTER //
// ./src/page/doc/DocRoute.js